var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"responsive"},[_c('img',{attrs:{"src":require('@/assets/beavers/beavers.png'),"title":"Zurück zur Hauptseite"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }